/* eslint-disable max-len */
export const SPEC_TITLE = 'Details';
export const CATEGORY_NAME = 'Appliance Category';
export const TYPE_NAME = 'Appliance Type';
export const FUEL_NAME = 'Fuel Type';
export const ATTRIBUTE_NAMES = ['Fuel Type', 'Dryer Fuel Type'];
export const SUPERDUPERSKU_NAMES = ['Fuel Type', 'Appliance Type'];
export const SEARCH_LABEL_NAME = 'Category';

export const TYPE_REG_EXP = /(electric|gas|induction|dual fuel|heatpump|commercial)/g;
export const CATEGORY_REG_EXP = /(?<!over the )(dryer|dryers|range|ranges)/g;

export const ENTRY_TYPES = ['ALERT', 'BASIC'];

export const ALERT_AND_HEADER = 'How to check if you need gas or electric.';

export const ELECTRIC = 'Electric';
export const GAS = 'Gas';
export const DUAL_FUEL = 'Use the information below to confirm your range power source. Keep in mind, there are a few ranges that have dual fuel hookups.';
export const TIP = 'Tip:';
export const HEADER_NAME_FUEL_TYPE = 'Fuel Type';
export const HEADER_NAME_APPLIANCE_TYPE = 'Appliance Type';

export const WASHER_VS_DRYER = 'All washers require a 3-Prong 120-Volt outlet, but dryer connections vary. Use the information below to confirm your dryer power source.';
export const INDUCTION = 'Induction ranges require the same hookup as electric.';
export const GAS_VALVE_CLARITY = 'For clarity, the gas valve illustration is shown open. Always shut it off before any maintenance, installation or inspection.';
export const MODEL_INFORMATION = ' Look up the model of the current appliance to confirm the connection. Model numbers can usually be found on the door, back or side of appliances.';
export const NEW_PARTS = 'Make sure to purchase new required parts as old parts might void the warranty of your new appliance. Some parts come with the purchase of installation.';
export const ADDITIONAL_GUIDANCE = 'For additional guidance go to ';
export const GAS_VS_ELECTRIC = {
  text: 'Gas vs Electric Stoves: Which Is Best?',
  url: 'https://www.homedepot.com/c/ab/gas-vs-electric-stoves/9ba683603be9fa5395fab9019e62223a'
};

export const ELECTRIC_OUTLET = 'require a 240-Volt outlet for three or four-prong electrical outlet within 4 feet of your new appliances.';
export const GAS_LINE = 'require a gas supply pipe with a shut-off valve directly behind the range and a standard 120-Volt outlet.';

export const IMAGES = {
  DRYER_THREE_PRONG: 'https://dam.thdstatic.com/content/production/VTz6k37-p5lS2vFpC3hQeQ/KFNoqXVGVmiH7fx2T3-7eA/Original%20file/7321000-d29a-dryer-outlet-240-volt-3-prong_05-08-2025.svg',
  DRYER_FOUR_PRONG: 'https://dam.thdstatic.com/content/production/iXXOKJU9Sv1J_fuy7kCIMQ/yXUAFAcKH1FvjpmtbFzVaQ/Original%20file/7321000-d29a-dryer-outlet-240-volt-4-prong_05-08-2025.svg',
  RANGE_THREE_PRONG: 'https://dam.thdstatic.com/content/production/cSJbmAafvUhV0tmOtl4i8Q/pCmGV1uNFJ-ctcFNSzLkog/Original%20file/7321000-d29a-oven-outlet-125-250-volt-3-prong_05-08-2025.svg',
  RANGE_FOUR_PRONG: 'https://dam.thdstatic.com/content/production/zmT-6Itws71fRxamKRxz0w/x51hmNyepJopin663wEFZA/Original%20file/7321000-d29a-oven-outlet-125-250-volt-4-prong_05-08-2025.svg',
  OUTLET_120_VOLT: 'https://dam.thdstatic.com/content/production/WMXHeJhd_z8Ua6XRhbdayA/L0hvdVhmuVHsiwJ0YRRfSw/Original%20file/7321000-d29a-outlet-120-volt-3-prong_05-08-2025.svg',
  GAS_VALVE: 'https://dam.thdstatic.com/content/production/TNizcinZTM4-OL9vkD2DGw/Qzc71g4IuBG6L52FPjceiQ/Original%20file/7321000-d29a-gas-valve_05-08-2025.svg'
};

export const DRYER_ELECTRIC_IMAGES = [
  {
    url: IMAGES.DRYER_THREE_PRONG,
    subText: '3 prong 240-Volt',
    height: '100px',
    width: '100px'
  },
  {
    url: IMAGES.DRYER_FOUR_PRONG,
    subText: '4 prong 240-Volt',
    height: '100px',
    width: '100px'
  }
];
export const RANGE_ELECTRIC_IMAGES = [
  {
    url: IMAGES.RANGE_THREE_PRONG,
    subText: '3 prong 240-Volt',
    height: '100px',
    width: '100px'
  },
  {
    url: IMAGES.RANGE_FOUR_PRONG,
    subText: '4 prong 240-Volt',
    height: '100px',
    width: '100px'
  }
];
export const GAS_IMAGES = [
  {
    url: IMAGES.GAS_VALVE,
    subText: 'Gas Valve',
    height: '80px',
    width: '143px'
  },
  {
    url: IMAGES.OUTLET_120_VOLT,
    subText: '3 prong 120-Volt',
    height: '65px',
    width: '71px'
  }
];
